export default {
  menu: 'Gifts',
  title: 'Gifts',

  general: {
    notifications: {
      insert: {
        success: 'Invoice registered successfully',
        error: 'Invoice registration was incorrect!'
      },

      edit: {
        success: 'Invoice edited successfully',
        error: 'Invoice editing encountered an error!'
      },

      delete: {
        success: 'Invoice successfully deleted',
        error: 'Deleting the gift invoice was accompanied by an error'
      },

      restore: {
        success: 'Invoice successfully restored',
        error: 'Restore sales invoice was accompanied by an error'
      }
    }
  },

  list: {
    title: 'Gifts'
  },

  insert: {
    title: 'Add gift invoice',

    telTypeTitle: 'Add Telephone Invoice',
    presentTypeTitle: 'Add Retail Gift Invoice'
  },

  invoice: {
    title: 'Gift Invoice',
    dynamicTitle: '{type} Gift {pre} Invoice No. {id}',
    dynamicTitleWithoutId: '{type} Gift Invoice',

    logs: {
      title: 'Gift invoice Logs'
    },

    print: {
      title: 'Gift invoice',
      preInvoice: 'Draft ',
      taxInvoice: 'Tax invoice '
    }
  },

  edit: {
    title: 'Edit Gift Invoice',
    dynamicTitle: 'Edit {type} Gift Invoice'
  },

  trash: {
    title: 'Gift invoice trash list'
  }
}
